import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    navigate("/admin", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink bg-grid flex items-center justify-center px-5" data-testid="admin-login-page">
      <form onSubmit={submit}
        className="w-full max-w-sm rounded-3xl border border-white/10 bg-card/60 backdrop-blur p-8 space-y-5">
        <div className="text-center">
          <img src="/logo.png" alt="Perez Osorio Painting Services" className="h-20 mx-auto rounded-xl bg-white p-1.5 mb-4" />
          <h1 className="font-display font-bold text-xl tracking-tight">Owner Access</h1>
          <p className="text-xs text-slate-500 mt-1 font-mono tracking-[0.2em] uppercase">Site Manager</p>
        </div>
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required
          data-testid="admin-login-email"
          className="bg-ink/60 border-white/15 text-white placeholder:text-slate-500 h-12 rounded-xl" />
        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required
          data-testid="admin-login-password"
          className="bg-ink/60 border-white/15 text-white placeholder:text-slate-500 h-12 rounded-xl" />
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="w-full rounded-xl bg-royal py-3.5 font-display font-bold hover:bg-royalhover transition-colors duration-200 disabled:opacity-60">
          {loading ? "Signing in..." : "Sign In"}
        </button>
        <a href="/" className="block text-center text-xs text-slate-500 hover:text-sky transition-colors">Back to website</a>
      </form>
    </div>
  );
}
